import {api} from '../../utils/api'

export default {

    /**
     * get all users tasks
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadAllUserTasks({commit}) {
        return api.call(commit, 'get', '/api/taskusers/all', null, 'SET_TASKUSERS');
    },

    /**
     * get all tasks
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadTaskusers({commit}, task_id) {
        return api.call(commit, 'get', '/api/taskusers/'+task_id, null, 'SET_TASKUSERS');
    },

    /**
     * get user roles for the tasks list
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadUserRoles({commit}, ids) {
        return api.call(commit, 'post', '/api/taskusers', {ids}, 'SET_TASKUSERS');
    },

    /**
     * get users collaborators
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadUsersCollaborators({commit}) {
        return api.call(commit, 'get', '/api/taskusers/collabs', false);
    },

    /**
     * get all user tasks for roles
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadUserTasks({commit}, ids) {
        return api.call(commit, 'post', '/api/taskusers/tasks', {ids}, 'SET_TASKUSERS');
    },

    /**
     * Register new taskuser
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    set({ commit }, {user_id, task_id, user_type}) {

        // Call register
        return api.call(commit, 'post', `/api/taskusers/${task_id}/${user_type}/${user_id}`, false, 'SET_TASKUSERS');
    },

    /**
     * Add new taskuser
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    add({ commit }, {user_id, task_id, user_type}) {

        // Call register
        return api.call(commit, 'post', `/api/taskusers/${task_id}/${user_type}/${user_id}`, false, 'SET_TASKUSERS');
    },

    /**
     * Remove taskuser
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    remove({ commit }, {user_id, task_id, user_type}) {

        // Call register
        return api.call(commit, 'delete', `/api/taskusers/${task_id}/${user_type}/${user_id}`, false, 'DELETE_TASKUSERS');
    },

    /**
     * Delete taskuser
     * @param commit
     * @param payload
     * @returns {Promise<any>}
     */
    delete({ commit },  {user_id, task_id, user_type}) {

        // Call register
        return api.call(commit, 'delete', `/api/taskusers/${task_id}/${user_type}/${user_id}`, false, 'DELETE_TASKUSERS');
    },

}
